import { ChebyshevCoefficients } from '@ootk/src/interpolator/ChebyshevCoefficients';
import { Seconds } from '@ootk/src/main';

export const gonggongChebyshevCoeffs: ChebyshevCoefficients[] = [
  new ChebyshevCoefficients(
    631152000 as Seconds,
    788940000 as Seconds,
    new Float64Array([
      19865672006.389858, 199016498.00673097, -901946.75557206466, 8779.5733805974323, -8917.5793198903393, 435.11012338002524, -512.4302782694499, 164.71649850209553,
      -157.64738909403482, -150.68779748280843, 507.64957504272462, 1.393869654337565,
    ]),
    new Float64Array([
      -11454075447.122353, 35254586.672187045, 631392.1195919672, 46728.46797173818, 618.57399145762122, -615.43882856369021, 93.67142492930094, -6.8228004137674967,
      115.68612855275472, 83.912257862091067, -151.47936035792031, -75.324421405792236,
    ]),
    new Float64Array([
      -8088737128.1798706, 112571016.35822658, 447928.8088898182, 17440.738390254974, 641.81113444964092, -378.71654329299929, 67.080865351359051, -169.75824755032858,
      -68.073165623346966, 205.73600546518961, -50.962044604619344, -166.04997332890829,
    ])
  ),
  new ChebyshevCoefficients(
    788940000 as Seconds,
    946728000 as Seconds,
    new Float64Array([
      20645385973.925644, 190432358.58214295, -1363906.0638163884, -49656.277269744875, 6763.6318354924515, 2213.7607990264892, -551.41398213704429, 19.24143174489339,
      -323.76515757242839, -152.05155124664307, 600.72687600453696, 61.954083315531413,
    ]),
    new Float64Array([
      -11300585089.590538, 41645505.932040274, 794743.74462731683, -48699.507725334166, -9456.0764967918403, 920.2698801040649, 120.92549142837524, 139.68556378682453,
      -16.07195898691813, -18.114559268951417, 132.68814754486084, -72.552371597290033,
    ]),
    new Float64Array([
      -7630418537.358449, 116640217.27038078, 499558.58840494155, -22001.778945970535, -3931.4276245117185, 174.4072250843048, 182.7356434504191, -96.267883348464963,
      -269.33175937334698, 85.938257344563795, 108.70326220194498, 23.027022679646809,
    ])
  ),
  new ChebyshevCoefficients(
    946728000 as Seconds,
    1104516000 as Seconds,
    new Float64Array([
      21385688920.142891, 180049559.75602549, -1007753.461388588, 60269.230771954855, -7355.715198008219, -885.81387551625573, -278.38382638295491, -109.67058315277099,
      -403.55434811909993, 127.81448523203532, 693.5801867167155, -32.357069079081214,
    ]),
    new Float64Array([
      -11125474853.131889, 45473565.313364185, 317066.04885606765, 24338.697466786703, 8026.8459059079487, -774.37279160817468, -29.736532497406007, -189.6786280632019,
      40.153958829243976, -69.54161752065022, 21.037435626983644, 87.376161734263107,
    ]),
    new Float64Array([
      -7157851632.5219135, 119425458.27283315, 258365.32017246881, 6612.4353548208874, 3914.4218377272286, -333.28365362485249, 116.83495643933614, -6.2946713606516518,
      -193.96796673138937, -84.134015846252439, 110.49576959609985, 65.649137767155963,
    ])
  ),
  new ChebyshevCoefficients(
    1104516000 as Seconds,
    1262304000 as Seconds,
    new Float64Array([
      22091386967.492294, 172784644.86909917, -1020878.6356966654, -56085.161248715718, -5010.503979301453, 689.33520005544028, -315.40508759816487, 28.806341679890949,
      -323.20014438629153, 70.753038088480636, 555.49983202616374, -31.454274050394694,
    ]),
    new Float64Array([
      -10935481218.623819, 49929702.083369635, 775784.12738345459, 13674.270117314656, -8211.6034251213077, -765.91716880798344, 304.51790456771852, -34.834967072804766,
      64.37017771402995, 14.366906229654948, -218.83284511566163, 28.643501504262289,
    ]),
    new Float64Array([
      -6674927608.4664049, 122189258.86889224, 429207.18882176082, 5040.7517165978752, -3235.1381335258484, -283.01136345863341, 218.88950317700704, 177.99791628519694,
      -169.04782506624858, -153.30218831698099, -4.5008467197418209, 89.781781371434533,
    ])
  ),
  new ChebyshevCoefficients(
    1262304000 as Seconds,
    1420092000 as Seconds,
    new Float64Array([
      22763070089.366459, 162859308.06933734, -1225009.3449397404, 61115.921779950462, 5431.6363921483353, -2465.4831812540688, -865.68353900909426, 147.48793468475341,
      -257.96147391001381, -3.956528345743815, 612.84408550262447, 25.038794136047365,
    ]),
    new Float64Array([
      -10725420767.700542, 54662397.682810277, 297358.99865229923, -34828.373484802243, 11277.456328996022, 568.62276566823323, -206.4283008257548, -72.516976102193198,
      -94.850857035319009, 181.70585247675578, -56.474126752217607, -149.06362374623617,
    ]),
    new Float64Array([
      -6180266564.5746994, 124938202.51966141, 205437.47724323272, -18380.577634700137, 4568.1563378651936, 370.86945768992103, -78.176924546559647, 207.36050348281859,
      0.079721148808797201, -118.6021414120992, 28.128454955418903, 46.560794591903687,
    ])
  ),
  new ChebyshevCoefficients(
    1420092000 as Seconds,
    1577880000 as Seconds,
    new Float64Array([
      23398756670.829388, 155332480.94363505, -827690.43229732511, -23419.085475222269, -7957.5117853164675, 122.21688760121663, -980.95573743184411, -292.43003997802737,
      -269.43944835662842, 155.3707799911499, 757.33658320109043, 76.497183227539068,
    ]),
    new Float64Array([
      -10501230025.894901, 57719725.027262941, 607410.9666511853, 44489.522683715819, -2882.388309987386, -929.37166948318475, -57.512063344319664, 25.363541698455812,
      -66.87677103678385, 32.62154432932536, 140.61130851109823, 20.967747338612874,
    ]),
    new Float64Array([
      -5677116910.8142033, 126733072.99302472, 307594.82115070027, 17882.64456841151, -1326.3684033711752, -164.80155738194784, -45.744960419336955, 271.29664696057637,
      145.33183677991232, -143.10923892656962, -14.266446336110432, -69.017332919438672,
    ])
  ),
  new ChebyshevCoefficients(
    1577880000 as Seconds,
    1735668000 as Seconds,
    new Float64Array([
      24003361884.026367, 146476982.95517102, -1371961.683509636, -6951.7071834564204, 13422.404950078328, 502.11243502298993, -1187.2757708867391, -144.45605971018472,
      -136.5307430267334, 88.050430679321295, 536.80411802927654, 22.639838918050131,
    ]),
    new Float64Array([
      -10259658808.427723, 62965256.002691299, 480550.68237565359, -70287.626486301422, -1414.0358150800068, 2179.9622452100116, 129.78331664403279, -158.69801918665567,
      -100.73879547119141, -56.181344763437906, 23.434838231404623, 96.150045490264887,
    ]),
    new Float64Array([
      -5164880080.6104994, 129338046.915006, 247374.43373034796, -31577.447759310406, -1202.8649610837301, 976.66969315210974, -42.786455122629803, -34.03693755467733,
      166.54666177431741, -28.018648449579874, -133.25604421297709, 25.689738829930622,
    ])
  ),
  new ChebyshevCoefficients(
    1735668000 as Seconds,
    1893456000 as Seconds,
    new Float64Array([
      24570233359.162441, 137454630.83718345, -833719.10151761374, 26647.725471242269, -9001.9054766337067, 368.28950831095375, -807.44758275349932, -39.312374560038251,
      -13.511433855692545, -99.686989974975589, 540.96297251383464, 64.363025601704919,
    ]),
    new Float64Array([
      -10003150380.21138, 65134645.422224298, 296803.11037247977, 43914.565462621053, 2836.5292621930439, -949.69671360651648, 126.82521251042684, 203.37878694534302,
      -11.353758939107259, -123.83483533859253, -125.62742760976155, 45.030380249023438,
    ]),
    new Float64Array([
      -4645054589.9191265, 130481928.24647439, 137838.08935670851, 16851.932073609034, 1259.005625518163, -483.83393832842506, -59.993507083257036, -82.217518536249798,
      231.58939237594603, 71.204995505015049, -165.20006920496621, -8.5427696704864502,
    ])
  ),
  new ChebyshevCoefficients(
    1893456000 as Seconds,
    2051244000 as Seconds,
    new Float64Array([
      25105951586.687912, 130116163.24339898, -1161544.7596574146, -57130.167561022441, 2331.1919822692871, 2149.860231653849, -709.51125113169348, -152.6397216161092,
      -325.32889016469318, -76.56448593139649, 771.33697433471684, 144.32212492624919,
    ]),
    new Float64Array([
      -9734991074.8924713, 69218184.617382139, 599002.49914102559, -26977.578983656564, -9983.6294310569756, 198.56772556304932, 215.44090735117595, 90.927027002970377,
      48.742083581288654, 30.382871341705322, -32.646260134379069, -102.28112726211548,
    ]),
    new Float64Array([
      -4119778619.7632627, 132266226.10195433, 258479.22390303612, -11353.15192159017, -4353.1708365122477, -49.090030336380003, -13.789414532979329, -219.8321861108144,
      81.988423649470008, 159.74243449370067, -84.72781939506531, -76.65119071801503,
    ])
  ),
  new ChebyshevCoefficients(
    2051244000 as Seconds,
    2209032000 as Seconds,
    new Float64Array([
      25607001238.665733, 120591754.96630217, -960539.56244227092, 67305.119623756415, -5001.0865818659468, -1432.8248213450113, -424.71041564941407, 76.211312866210932,
      -428.30071207682289, 7.343149948120117, 756.85308767954507, -46.548810195922854,
    ]),
    new Float64Array([
      -9452225518.7828426, 71703588.250260189, 102081.57324937184, 11298.662383874258, 10353.269191424051, -744.99429044723513, -246.27205607096354, 256.59840634663897,
      -28.13959248860677, -153.75240605672201, 56.49916410446167, 14.096113395690917,
    ]),
    new Float64Array([
      -3588250093.2643428, 133282505.82540388, 23939.779532583554, 1948.8661272366842, 4671.0957684993746, -505.50150715510051, -109.07507623036702, -240.58228232860566,
      -86.517435161272687, 144.97140595912933, 75.239777135848996, 84.061942148208615,
    ])
  ),
  new ChebyshevCoefficients(
    2209032000 as Seconds,
    2366820000 as Seconds,
    new Float64Array([
      26076422417.468559, 114208496.95007546, -852974.35038611095, -50509.606529744466, -6815.8764228185019, 498.9872485478719, -643.8906070709229, 50.362864303588864,
      -280.0106648127238, -56.199094136555992, 727.81266244252527, 102.13651218414307,
    ]),
    new Float64Array([
      -9160960780.1535854, 74356976.652470395, 584764.69409503939, 27666.449420261382, -6735.8936607042951, -515.54694662094118, 67.830422178904215, -96.685538101196286,
      63.392185306549074, -114.8139376004537, -75.601055908203122, 158.77413431803384,
    ]),
    new Float64Array([
      -3053690291.6681981, 134166349.59203625, 212863.07507111231, 11924.779467670123, -2474.6702199220658, -238.64067025979361, 64.140328860282892, -105.75794742107391,
      -121.54348160425822, 19.25726671218872, 102.38755030632019, -11.303942457834879,
    ])
  ),
  new ChebyshevCoefficients(
    2366820000 as Seconds,
    2493072000 as Seconds,
    new Float64Array([
      26474504679.389244, 84909113.462025955, -824633.5162624995, 13681.313825861613, 4801.9033796310423, -411.34887027740479, -1086.7906959533691, 94.072045771280926,
      311.60414886474609, 42.857894070943196, 1225.3523045857746, -42.024413108825684,
    ]),
    new Float64Array([
      -8886561633.5518017, 62433419.368649453, 159936.56670618057, -34558.383391698204, 2262.897873878479, 817.51445140838621, -13.782485516866048, -141.85642576217651,
      -113.65321518580119, 26.862492434183757, 21.036620680491129, -1.3419598897298177,
    ]),
    new Float64Array([
      -2568242770.9554381, 108394964.71610846, 43133.465593504909, -15951.256612483659, 855.04204521973929, 136.30106352965038, -188.25339915752411, 188.24033966859182,
      19.879144128163656, -91.334226171175644, 28.492356753349302, 24.260063576698304,
    ])
  ),
];
